import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { isToday } from 'date-fns';

import { datePickerMessages } from "./datePickerMessages";

export const DatePickerFieldMessage = ({ selectedDate }) =>
    (
        <div className="field-msg delivery-date-time-message">
            {!isToday(selectedDate) ?
                (
                    <FormattedMessage {...{ ...datePickerMessages.datePickerDeliveryMessageFuture, values: { strong: msg => <span style={{ fontWeight: 'bold' }}>{msg}</span> } }} />
                )
                : null}
        </div>
    );

DatePickerFieldMessage.propTypes = {
    selectedDate: PropTypes.instanceOf(Date).isRequired
};

